import $ from 'jquery';
import Swal from 'sweetalert2';
import { removeQuote, saveQuote } from '../../api';

export const handleSaveQuoteBtn = (event) => {
  event.preventDefault();
  const text = $('#editor-add-quote-value').val();
  const category = $('#select-categories-create-quote').val();
  if (!category) {
    Swal.fire({
      icon: 'error',
      title: 'Oops',
      text: 'Non è stata selezionata una categoria.',
      confirmButtonColor: '#278e8e',
    });
    return;
  }
  if (text) {
    $(event.currentTarget).prop('disabled', true);
    $('#button-clean-html-quotes').prop('disabled', true);
    $('#button-clean-html-quotes').hide();
    $('#editor-add-quote-value').prop('disabled', true);
    $('#editor-btn-spinner-quotes').show();
    $('#button-save-quote span').text('Salvataggio in corso');
    saveQuote(text, category);
  }
};

export const handleDeleteQuoteBtn = (event) => {
  event.preventDefault();
  const editorQuoteId = $(event.currentTarget).data('quote-id');

  Swal.fire({
    title: 'Sei sicuro?',
    text: 'Vuoi cancellare la frase?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#278e8e',
    cancelButtonColor: '#d33',
    cancelButtonText: 'No',
    confirmButtonText: 'Si, elimina',
  }).then((result) => {
    if (result.value) {
      Swal.fire({
        text: 'Sto eliminando la frase...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: false,
        confirmButtonColor: '#278e8e',
        didOpen: () => {
          Swal.showLoading();
        },
      });

      removeQuote(editorQuoteId).then(() => {
        Swal.hideLoading();
        Swal.fire({
          title: 'Fatto!',
          html: 'La frase &egrave; stata eliminata.',
          icon: 'success',
          confirmButtonColor: '#278e8e',
        });
      });
    }
  });
};
